// extracted by mini-css-extract-plugin
export default {"rating":"DB-z","numberOfStars":"EB-z","count":"FB-z","barGraphSpacing":"GB-z","barGraph":"HB-z"};